import * as React from 'react';

import PropTypes from 'prop-types';

import LinkConstants from 'constants/LinkConstants';
// @ts-ignore
import OrganizationProfile from 'entities/OrganizationProfile';
// @ts-ignore
import remindWwwRequest from 'lib/remindWwwRequest';
import { OrganizationEngagementView } from 'organizations/components/OrganizationEngagementView';
import { EngagementRating } from 'organizations/constants/EngagementRatings';

type Props = {
  params: { organizationId: string };
};

export type Organization = {
  city: string;
  great_schools_url: string;
  max_rating: EngagementRating | undefined;
  org_name: string;
  peak_teacher_student_parent: number;
  perc_active: number;
  perc_emerging: number;
  perc_engaged: number;
  perc_growing: number;
  state: string;
  url: string;
};

type CommunicationStats = {
  announcements: number;
  conversations: number;
  date: string;
};

export type Stats = {
  communication_usage: {
    chart: Array<CommunicationStats>;
  };
};

type State = {
  organization: Organization | undefined;
  stats: Stats | undefined;
};

export default class OrganizationEngagementViewDataContainer extends React.Component<Props, State> {
  // eslint-disable-next-line @remind/remind/legacy-context
  static contextTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    router: PropTypes.object.isRequired,
  };

  state: State = {
    organization: undefined,
    stats: undefined,
  };

  componentDidMount() {
    this.loadOrg(this.props.params.organizationId);
  }

  getProfile = (orgUuid: string) => {
    const onSuccess = (response: Organization) => {
      if (!response) {
        this.redirect();
      }

      this.setState({ organization: response });
    };

    const onError = () => {
      this.redirect();
    };

    return remindWwwRequest(`/district_pages/${orgUuid}/profile`).then(onSuccess, onError);
  };

  getStats = (orgUuid: string) => {
    const onSuccess = (response: Stats) => {
      if (!response) {
        return;
      }

      this.setState({ stats: response });
    };

    return remindWwwRequest(`/district_pages/${orgUuid}/usage`).then(onSuccess);
  };

  // `organizationId` can be the org id or org slug
  loadOrg = (organizationId: number | string) => {
    OrganizationProfile.fetch({ id: organizationId }).then(
      (organizationProfile: OrganizationProfile) => {
        const organizationUuid = organizationProfile.getUuid();

        this.getProfile(organizationUuid);
        this.getStats(organizationUuid);
      },
      () => {
        this.redirect();
      }
    );
  };

  redirect = () => {
    window.location.href = LinkConstants.PLANS;
  };

  render() {
    const { organization, stats } = this.state;

    if (!organization) {
      return null;
    }

    return <OrganizationEngagementView organization={organization} stats={stats} />;
  }
}
